<template>
  <div class="modal fade" id="mdlSalida" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Confirmación</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="reco">
          <p><b>Observaciones:</b> {{ reco.observaciones }}</p>
          <form @submit.prevent="enviarConfirmacion">
            <div class="form-group mb-1">
              <label class="col-form-label">Fecha:</label>
              <date-picker v-model="fechaConfirma" class="form-control form-control-sm" :config="{format: 'YYYY-MM-DD',useCurrent: false}" :required="true"></date-picker>
            </div>
            <div class="form-group mb-1">
              <label class="col-form-label">Hora cierre: <span class="text-danger font-weight-bold">*</span></label>
              <date-picker v-model="horaCierre" class="form-control form-control-sm" :config="{format: 'HH:mm:ss',useCurrent: false}" :required="true"></date-picker>
            </div>
            <p v-if="conmensaje" class="text-info text-center">
              {{ conmensaje }} <br>
              <a :href="UrlBase+'/recoleccion/imprimir/'+reco.id" target="_blank">Imprimir solicitud</a>
            </p>
            <div class="form-group row mb-1" v-if="!reco.fecha_salida">
              <div class="col-sm-12 text-right">
                <button class="btn btn-sm btn-primary" :disabled="btnConfirmacion">
                  <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnConfirmacion"
                  ></span>
                  <span v-else>
                    <i class="fa fa-save"></i> Guardar
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'GuiaRecoleccionConfirmar',
    props: {
      reco: {
        type: Object,
        required: false,
        default: null
      }
    },
    data: () => {
      return {
        btnConfirmacion: false,
        conmensaje: null,
        fechaConfirma: null,
        horaCierre: null
      }
    },
    methods: {
      enviarConfirmacion () {
        if (confirm('¿Está seguro?')) {
          this.btnConfirmacion = true;
          axios
          .post(`${this.UrlBase}/recoleccion/set_confirmacion/${this.reco.id}`, {fecha_salida: this.fechaConfirma, hora_cierre: this.horaCierre})
          .then(res => {
            this.btnConfirmacion = false;
            if (res.data.exito) {
              this.conmensaje = res.data.mensaje;
              this.reco.fecha_salida = this.fechaConfirma;
              this.reco.hora_cierre = this.horaCierre;
            } else {
              alert(res.data.mensaje);
            }
          }).catch(e => {
            this.btnConfirmacion = false;
            alert('Confirmación '+e);
          })
        }
      },
    }
  }
</script>